import React, { createContext, useContext, useEffect, useState } from "react";

type RecentlyViewedContextType = {
  viewedProductIds: string[];
  addViewedProduct: (id: string) => void;
};

const RecentlyViewedContext = createContext<RecentlyViewedContextType | null>(null);

export const RecentlyViewedProvider = ({ children }: { children: React.ReactNode }) => {
  const [viewedProductIds, setViewedProductIds] = useState<string[]>([]);

  useEffect(() => {
    const saved = localStorage.getItem("recently_viewed_products");
    if (saved) {
      try {
        setViewedProductIds(JSON.parse(saved));
      } catch (e) {
        console.error("Failed to parse recently viewed products", e);
      }
    }
  }, []);

  const addViewedProduct = (id: string) => {
    setViewedProductIds((prev) => {
      // Remove any existing instance of the id seamlessly
      const filtered = prev.filter(productId => productId !== id);
      // Prepend to start of array, capping at 15 items max memory
      const updated = [id, ...filtered].slice(0, 15);
      localStorage.setItem("recently_viewed_products", JSON.stringify(updated));
      return updated;
    });
  };

  return (
    <RecentlyViewedContext.Provider value={{ viewedProductIds, addViewedProduct }}>
      {children}
    </RecentlyViewedContext.Provider>
  );
};

export const useRecentlyViewed = () => {
  const ctx = useContext(RecentlyViewedContext);
  if (!ctx) throw new Error("useRecentlyViewed must be used inside RecentlyViewedProvider");
  return ctx;
};
